import React from 'react';
import { TrendingUpIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-[#faf5eb] text-slate-900 py-20 px-4 sm:px-6 lg:px-8" data-id="element-172">
      <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-amber-100" data-id="element-173">
        <div className="md:flex" data-id="element-174">
          <div className="md:w-1/3 bg-amber-500 p-8 flex flex-col justify-center items-center text-center text-slate-900" data-id="element-175">
            <TrendingUpIcon className="w-16 h-16 mb-4 opacity-80" data-id="element-176" />
            <h3 className="text-2xl font-extrabold" data-id="element-177">
              Lo que cambia en 30 días
            </h3>
          </div>
          <div className="md:w-2/3 p-8 md:p-10" data-id="element-178">
            <p className="text-lg text-slate-700 leading-relaxed" data-id="element-179">
              No vas a ser millonario el próximo mes, pero vas a llegar al día
              30 con{' '}
              <strong className="text-slate-900" data-id="element-180">
                saldo positivo en tu cuenta
              </strong>
              .
            </p>
            <p className="text-lg text-slate-700 leading-relaxed mt-4" data-id="element-181">
              La mayoría de los lectores reportan una{' '}
              <strong className="text-amber-600" data-id="element-182">
                reducción del 20% en "gastos basura"
              </strong>{' '}
              desde la primera semana de implementación sin sentir que se están
              privando de lo importante.
            </p>
          </div>
        </div>
      </div>
    </section>;
}